import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { blogCategoryPath, blogPath } from "@/lib/routes";
import type { BlogCategory } from "@/types/blog";

type BlogCategoryNavProps = {
  locale: "tr" | "en";
  categories: BlogCategory[];
  activeSlug?: string;
  className?: string;
};

export function BlogCategoryNav({ locale, categories, activeSlug, className }: BlogCategoryNavProps) {
  const isTr = locale === "tr";

  if (categories.length === 0) {
    return null;
  }

  return (
    <nav className={cn("flex flex-wrap gap-2", className)} aria-label={isTr ? "Blog kategorileri" : "Blog categories"}>
      <Link
        to={blogPath(locale)}
        className={cn(
          "rounded-full border px-3.5 py-1.5 text-sm font-semibold no-underline transition",
          !activeSlug
            ? "border-enabase-blue/30 bg-enabase-blue/10 text-accent-link"
            : "border-[var(--border)] bg-[var(--card)] text-[var(--text-md)] hover:border-enabase-blue/25 hover:text-accent-link"
        )}
      >
        {isTr ? "Tümü" : "All"}
      </Link>
      {categories.map((category) => (
        <Link
          key={category.id}
          to={blogCategoryPath(locale, category.slug)}
          className={cn(
            "rounded-full border px-3.5 py-1.5 text-sm font-semibold no-underline transition",
            activeSlug === category.slug
              ? "border-enabase-blue/30 bg-enabase-blue/10 text-accent-link"
              : "border-[var(--border)] bg-[var(--card)] text-[var(--text-md)] hover:border-enabase-blue/25 hover:text-accent-link"
          )}
        >
          {category.label}
          {category.postCount > 0 ? (
            <span className="ml-1.5 text-xs font-medium opacity-70">{category.postCount}</span>
          ) : null}
        </Link>
      ))}
    </nav>
  );
}
